/** Route paths for the Doubts module (relative to module base path) */
export const DOUBTS_ROUTES = {
  LIST: "",
  DETAIL: "page2",
  AINA_CHAT: "aina-chat",
} as const;
